export class FileUtils {
    static GetFileSize(bytes, si = false) {
        const thresh = si ? 1000 : 1024;
        if(Math.abs(bytes) < thresh) {
            return Math.abs(bytes) + ' B';
        }
        const units = si
            ? ['kB','MB','GB','TB','PB','EB','ZB','YB']
            : ['KiB','MiB','GiB','TiB','PiB','EiB','ZiB','YiB'];
        let u = -1;
        do {
            bytes /= thresh;
            ++u;
        } while(Math.abs(bytes) >= thresh && u < units.length - 1);

        return Math.abs(bytes).toFixed(1)+' '+units[u];
    }

    // From: https://stackoverflow.com/a/67994693/385979
    static GetFileNameFromContentDisposition(disposition) {
        const utf8FilenameRegex = /filename\*=UTF-8''([\w%\-\.]+)(?:; ?|$)/i;
        const asciiFilenameRegex = /filename=(["']?)(.*?[^\\])\1(?:; ?|$)/i;

        let fileName = null;
        if (utf8FilenameRegex.test(disposition)) {
            fileName = decodeURIComponent(utf8FilenameRegex.exec(disposition)[1]);
        } else {
            const matches = asciiFilenameRegex.exec(disposition);
            if (matches != null && matches[2]) {
                fileName = matches[2];
            }
        }
        return fileName;
    }
    static ParseHTTPRangeHeader(headerValue) {
        let start = null, end = null;
        if(headerValue && (typeof headerValue === 'string' || headerValue instanceof String)) {
            const beginningOfTheEnd = headerValue.lastIndexOf('-');
            start = Number(headerValue.substring('bytes='.length, beginningOfTheEnd));
            end = Number(headerValue.substring(beginningOfTheEnd + 1));
        }
        return {start, end};
    }
    
    /**
     * Saves a file download from a fetch promise.
     * 
     * @param fetchPromise
     * @returns {Promise<void>}
     * @constructor
     */
    static SaveFileDownload = async (fetchPromise) => {
        const response = await fetchPromise;
        const anchor = document.createElement("a");
        
        if (!response.ok) {
            const data = await response.json().catch(() => null);
            const errorMessage = data?.message ? `\n${data.message}` : '';
            
            throw response.statusText + errorMessage;
        }
        
        const filename = FileUtils.GetFileNameFromContentDisposition(response.headers.get('Content-Disposition'));
        const blobby = await response.blob();
        const objectUrl = window.URL.createObjectURL(blobby);
        
        try {
            anchor.href = objectUrl;
            anchor.download = filename;
            anchor.click();
        } finally {
            URL.revokeObjectURL(objectUrl);
        }
    }
}
